import React, { createContext, useContext, useState } from 'react';

// 1. Create the Context
const CompareContext = createContext();

// 2. Create a custom hook for easy access
export const useCompare = () => {
  return useContext(CompareContext);
};

// 3. Create the Provider component
export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]); // This is our global state

  // Function to add a fund
  // Function to add a fund
  const addFundToCompare = (fund) => {
    // Check if fund is already in the list
    if (compareList.find(item => item.schemeCode === fund.schemeCode)) {
      console.warn(`${fund.schemeName} is already in your compare list.`); // <-- CHANGED
      return;
    }
    
    // Limit to 4 funds
    if (compareList.length >= 4) {
      console.warn('You can only compare up to 4 funds at a time.'); // <-- CHANGED
      return;
    }

    // Add the new fund...
    setCompareList(prevList => [
      ...prevList, 
      { schemeCode: fund.schemeCode, schemeName: fund.schemeName }
    ]);
  };

  // Function to remove a fund
  const removeFundFromCompare = (schemeCode) => {
    setCompareList(prevList => 
      prevList.filter(item => item.schemeCode !== schemeCode)
    );
  };

  // The value to be passed to all child components
  const value = {
    compareList,
    addFundToCompare,
    removeFundFromCompare,
    compareCount: compareList.length
  };

  return (
    <CompareContext.Provider value={value}>
      {children}
    </CompareContext.Provider>
  );
};